module.exports = __webpack_public_path__ + "static/media/file-upload.cfbb1428.svg";